import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px;
    background: #343758;
    @media screen and (max-width: 780px) {
        padding: 32px 20px;
    }
`;

export const RequestDemoButton = styled.div`
    display: flex;
    justify-content: center;
    border: 1px solid #5bdb89;
    box-sizing: border-box;
    border-radius: 8px;
    color: #5bdb89;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    cursor: pointer;
    padding: 12px;
    margin-top: 24px;
    @media screen and (min-width: 780px) {
        padding: 16px 0;
        width: 190px;
    }
`;

export const Heading = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 800;
    font-size: 26px;
    line-height: 31px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #ffffff;
    @media screen and (max-width: 780px) {
        font-size: 26px;
        letter-spacing: 0.02em;
        justify-content: flex-start;
    }
`;

export const SubHeading = styled.div`
    display: flex;
    justify-content: center;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #8a99a9;
    margin-top: 11px;
    @media screen and (max-width: 780px) {
        font-size: 12px;
        letter-spacing: 0.02em;
        margin-top: 8px;
        justify-content: flex-start;
    }
`;

export const RequestDemoButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    @media screen and (max-width: 780px) {
        justify-content: flex-start;
    }
`;
